export default {
  'nav.manifesto': 'Manifesto',
  'nav.collections': 'Collections',
  'nav.society': 'Society',
  'nav.narrative': 'Narrative',
  'nav.community': 'Community',
  'nav.contact': 'Contact',

  'hero.est': 'Est. 2025',
  'hero.title1': 'Premium',
  'hero.title2': 'Pet Care',
  'hero.title3': 'Ecosystem',
  'hero.subtitle': 'Where urban pet care meets editorial precision. We do not just walk dogs, we curate experiences for the modern pet parent.',
  'hero.quote': '"The most thoughtful pet care service I have ever experienced."',
  'hero.quoteSource': '— Vogue Pets Magazine',

  'booking.title': 'Book a Session',
  'booking.subtitle': 'Select your service and preferred time',
  'booking.service': 'Service',
  'booking.selectService': 'Select a service',
  'booking.date': 'Date',
  'booking.time': 'Time',
  'booking.selectTime': 'Select a time',
  'booking.submit': 'Book Session',
  'booking.sent': 'Request Sent',

  'services.label': 'What We Offer',
  'services.title': 'The Collections',
  'services.walking.title': 'Walking Services',
  'services.walking.desc': 'Urban routes designed for energy, socialization, and discovery. Our trained walkers navigate city parks, riverside trails, and hidden green corridors.',
  'services.walking.price': 'From $28 / walk',
  'services.sitting.title': 'Home Sitting',
  'services.sitting.desc': 'Your pet stays in their familiar environment while receiving round-the-clock care. Daily updates, medication management, and companionship included.',
  'services.sitting.price': 'From $65 / day',
  'services.training.title': 'Behavior Training',
  'services.training.desc': 'Certified trainers using positive reinforcement methods. From puppy basics to advanced obedience, we build lasting bonds between you and your companion.',
  'services.training.price': 'From $85 / session',
  'services.grooming.title': 'Grooming Studio',
  'services.grooming.desc': 'Boutique grooming with premium products. Bath, cut, nail care, and styling. Every session ends with a complimentary bandana or bow.',
  'services.grooming.price': 'From $45 / session',

  'matchmaking.label': 'Pet Matchmaking',
  'matchmaking.title': 'Find Your Match',
  'matchmaking.subtitle': 'Browse available companions waiting for their forever home',
  'matchmaking.viewProfile': 'View Profile →',
  'matchmaking.loadMore': 'Load More Profiles',

  'narrative.label': 'Our Narrative',
  'narrative.title': 'Built on Trust, Designed for Community',
  'narrative.p1': 'Paw & Co. began with a simple observation: urban pet parents deserved better. Not just better care, but a better experience. One that felt intentional, thoughtful, and genuinely connected to the rhythms of city life.',
  'narrative.p2': 'We assembled a team of certified trainers, experienced walkers, and passionate caregivers who share one belief: every pet interaction should be meaningful. From the first consultation to the hundredth walk, consistency and care remain our north star.',
  'narrative.p3': 'Today, we serve four boroughs with a network of 18 expert caregivers, each vetted, trained, and committed to the Paw & Co. standard of excellence.',
  'narrative.stat1': 'Happy Pets',
  'narrative.stat2': 'Expert Caregivers',
  'narrative.stat3': 'Boroughs Served',
  'narrative.stat4': 'Satisfaction Rate',
  'narrative.feature1.title': 'Certified Caregivers',
  'narrative.feature1.desc': 'Every team member undergoes rigorous training in pet first aid, behavior reading, and urban safety protocols before joining our roster.',
  'narrative.feature2.title': 'Real-Time Updates',
  'narrative.feature2.desc': 'GPS-tracked walks, photo updates, and detailed session reports delivered to your inbox after every appointment.',
  'narrative.feature3.title': 'Community Events',
  'narrative.feature3.desc': 'Monthly meetups, training workshops, and seasonal gatherings that connect pet parents across the city.',

  'community.title': 'Trusted by 2,400+ Pet Parents',
  'community.review1.headline': 'Exceptional care for Max',
  'community.review1.body': 'Paw & Co. transformed our daily routine. The walking service is punctual, professional, and Max comes home genuinely happy. We have tried three other services before finding them.',
  'community.review1.author': 'Sarah Mitchell',
  'community.review1.role': 'Dog parent, Brooklyn',
  'community.review2.headline': 'Training that actually works',
  'community.review2.body': 'After six weeks with their behavior specialist, our rescue dog went from anxious to confident. The positive reinforcement approach made all the difference.',
  'community.review2.author': 'James Chen',
  'community.review2.role': 'First-time adopter',
  'community.review3.headline': 'The grooming is art',
  'community.review3.body': 'I have never seen my poodle look this good. The attention to detail is remarkable, and the boutique products they use leave her coat silky for weeks.',
  'community.review3.author': 'Elena Rodriguez',
  'community.review3.role': 'Poodle owner, Manhattan',
  'community.review4.headline': 'Peace of mind while traveling',
  'community.review4.body': 'Their home sitting service gave us complete peace of mind during our two-week trip. Daily photo updates and detailed reports kept us connected to our cats.',
  'community.review4.author': 'David Park',
  'community.review4.role': 'Cat parent, Queens',
  'community.review5.headline': 'Found our perfect match',
  'community.review5.body': 'The pet matchmaking service connected us with a rescue that fits our lifestyle perfectly. The compatibility assessment was thorough and thoughtful.',
  'community.review5.author': 'Amara Okafor',
  'community.review5.role': 'New pet parent',
  'community.review6.headline': 'Community that cares',
  'community.review6.body': 'Beyond the services, Paw & Co. has built a genuine community. The monthly meetups and workshops have connected us with fellow pet parents who share our values.',
  'community.review6.author': 'Thomas Wright',
  'community.review6.role': 'Community member',

  'contact.label': 'Get in Touch',
  'contact.title': 'Start the Conversation',
  'contact.desc': 'Whether you are ready to book or just exploring options, we are here to answer your questions. Every pet is unique, and so is our approach.',
  'contact.visit': 'Visit Us',
  'contact.address': '128 Bark Street, Brooklyn, NY 11201',
  'contact.email': 'Email',
  'contact.emailValue': 'hello@pawandco.com',
  'contact.phone': 'Phone',
  'contact.phoneValue': '+1 (718) 555-0147',
  'contact.form.name': 'Name',
  'contact.form.namePlaceholder': 'Your name',
  'contact.form.email': 'Email',
  'contact.form.emailPlaceholder': 'your@email.com',
  'contact.form.message': 'Message',
  'contact.form.messagePlaceholder': 'Tell us about your pet and what you need...',
  'contact.form.submit': 'Send Message',
  'contact.form.sent': 'Message Sent',

  'footer.tagline': 'Premium care since 2025. Curated experiences for the modern pet parent.',
  'footer.services': 'Services',
  'footer.company': 'Company',
  'footer.resources': 'Resources',
  'footer.copyright': '© 2025 Paw & Co. All rights reserved.',
  'footer.privacy': 'Privacy',
  'footer.terms': 'Terms',
};